/**
 * Escapes one CSV cell.
 *
 * Every value is quoted and inner quotes doubled, so a URL carrying a comma survives the round
 * trip. Text that starts with =, +, @ or - is prefixed with an apostrophe first: spreadsheets
 * read those as formulas, and a page path beginning with one would otherwise execute on open.
 * Leading whitespace is included in that test because it does not stop the interpretation.
 *
 * An absent value stays empty rather than becoming a 0 — the reason it is absent travels in its
 * own column.
 */
export function csvCell(value) {
    if (value === null || value === undefined) return '""';

    const raw = String(value);
    const safe = typeof value === 'string' && /^\s*[=+@-]/.test(raw) ? `'${raw}` : raw;

    return `"${safe.split('"').join('""')}"`;
}

export function csvText(rows) {
    return rows.map((row) => row.map(csvCell).join(',')).join('\r\n');
}

/**
 * Hands the rows to the user as a file. The blob is built and revoked in the browser: nothing is
 * uploaded, stored or turned into a shareable link, so the export is the user's own copy of what
 * they are already looking at.
 */
export function downloadCsv(rows, filename) {
    const blob = new Blob([csvText(rows)], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = filename;
    link.click();

    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
